<div class="column-layout-container" basepage="primary">
  <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
    <aside role="region" aria-label="side navigation">
      <div class="menu-top d-flex justify-content-between align-items-center">
        <fui-heading [text]="'Orders' | translate" [level]="5"></fui-heading>
        <div>
          <!-- <button class="fa-button m-r-10" placement="bottom" [ngbTooltip]="(refreshing ? 'general.refreshing_dots' : 'general.refresh') | translate" (click)="refresh()">
          <fa-icon icon="sync" class="action refresh circle-icon-btn" [animation]="refreshing ? 'spin' : undefined"></fa-icon>
        </button> -->
        </div>
      </div>

      <ul class="menu-options">
        <li class="menu-option" [class.active]="displayedSection == 'orders'">
          <a
            class="primary-option"
            tabindex="0"
            href="javascript:void(0);"
            (keyup.enter)="appService.mobileMenuShown = false; switchSection('orders')"
            (keyup.space)="appService.mobileMenuShown = false; switchSection('orders')"
            (click)="appService.mobileMenuShown = false; switchSection('orders')"
          >
            My Orders
          </a>
        </li>
        <li class="menu-option" [class.active]="displayedSection == 'addresses'">
          <a
            class="primary-option"
            tabindex="0"
            href="javascript:void(0);"
            (keyup.enter)="appService.mobileMenuShown = false; switchSection('addresses')"
            (keyup.space)="appService.mobileMenuShown = false; switchSection('addresses')"
            (click)="appService.mobileMenuShown = false; switchSection('addresses')"
          >
            Address Book
          </a>
        </li>
        <li class="menu-option" [class.active]="displayedSection == 'gift_cards'">
          <a
            class="primary-option"
            tabindex="0"
            href="javascript:void(0);"
            (keyup.enter)="appService.mobileMenuShown = false; switchSection('gift_cards')"
            (keyup.space)="appService.mobileMenuShown = false; switchSection('gift_cards')"
            (click)="appService.mobileMenuShown = false; switchSection('gift_cards')"
          >
            Gift Cards
          </a>
        </li>
      </ul>
    </aside>
  </div>
  <section class="content animate-in-from-right" [class.mobile-shown]="!appService.mobileMenuShown">
    <button class="mobile-back-btn no-border" (click)="appService.mobileMenuShown = true">
      <fa-icon icon="chevron-left" aria-hidden="true"></fa-icon>
      Orders Options
    </button>
    @if (displayedSection == "orders") {
      <div class="container">
        <fui-heading [text]="'My Orders'" [level]="5"></fui-heading>
        <br />
        @if (!loading && !orders?.length && !fenderOrders?.length) {
          <div class="m-y-20 text-muted">No orders to display.</div>
        }
        @if (!loading && orders?.length) {
          <myp-user-order-list [orders]="orders"></myp-user-order-list>
        }
        @if (!loading && fenderOrders?.length) {
          @for (order of fenderOrders; track order) {
            <myp-list-item
              [item]="orderService"
              [includeChevron]="false"
              [showImage]="true"
              [title]="order.description"
              [photo]="order.lineItems[0].image.src"
              [imageRound]="false"
              [collapsible]="true"
              [showBackground]="true"
              [metadata]="orderMetadata[order.id]"
              marginBottom="10px"
            >
              <div class="collapsible-content">
                <div class="row">
                  <div class="col-12">
                    <fui-heading text="In This Order" [level]="6"></fui-heading>
                    <br />
                    @for (item of order.lineItems; track item) {
                      <div class="m-y-10">
                        <div class="d-flex align-items-start">
                          <img [src]="item.image.src" [alt]="item.title" class="m-r-10" style="width: 50px" />
                          <div class="flex-grow-1">
                            <div class="bold">{{ item.title }}</div>
                            <div class="text-muted">{{ item.variantTitle }}</div>
                            <div class="text-muted">SKU: {{ item.sku }}</div>
                            <div class="m-t-10">
                              <div>Quantity: {{ item.quantity }}</div>
                              @if (item.originalTotal.amount !== item.discountedTotal.amount) {
                                <div>
                                  <span class="text-muted" style="text-decoration: line-through">{{ item.originalTotal.amount }} {{ item.originalTotal.currency }}</span>
                                  <span class="bold m-l-10">{{ item.discountedTotal.amount }} {{ item.discountedTotal.currency }}</span>
                                </div>
                              }
                              @if (item.originalTotal.amount === item.discountedTotal.amount) {
                                <div>
                                  <span class="bold">{{ item.discountedTotal.amount }} {{ item.discountedTotal.currency }}</span>
                                </div>
                              }
                              @if (item.taxLines?.length) {
                                <div class="m-t-5">
                                  @for (tax of item.taxLines; track tax) {
                                    <div class="text-muted">{{ tax.title }}: {{ tax.priceSet.amount }} {{ tax.priceSet.currency }} ({{ tax.rate * 100 }}%)</div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        <hr />
                      </div>
                    }
                    <div class="d-flex justify-content-end m-b-30">
                      <fui-heading text="Order Total: {{ order.totalPrice.amount + ' ' + order.totalPrice.currency }}" [level]="6"></fui-heading>
                    </div>
                    <fui-heading text="Shipments" [level]="6"></fui-heading>
                    <br />
                    @for (fulfillment of order.fulfillments; track fulfillment) {
                      <div class="m-b-20">
                        <div class="bold">{{ fulfillment.name }}</div>
                        <div class="m-t-5">
                          <div>
                            Status:
                            <span class="bold">{{ fulfillment.displayStatus }}</span>
                          </div>
                          @if (fulfillment.createdAt) {
                            <div>Created: {{ fulfillment.createdAt | date }}</div>
                          }
                          @if (fulfillment.inTransitAt) {
                            <div>In Transit: {{ fulfillment.inTransitAt | date }}</div>
                          }
                          @if (fulfillment.estimatedDeliveryAt) {
                            <div>Estimated Delivery: {{ fulfillment.estimatedDeliveryAt | date }}</div>
                          }
                          @if (fulfillment.deliveredAt) {
                            <div>Delivered: {{ fulfillment.deliveredAt | date }}</div>
                          }
                          @if (fulfillment.updatedAt) {
                            <div>Last Updated: {{ fulfillment.updatedAt | date }}</div>
                          }
                        </div>
                        @for (tracking of fulfillment.trackingInfo; track tracking) {
                          <div class="m-t-10">
                            <div class="bold">
                              {{ tracking.company }} Tracking:
                              <a href="{{ tracking.url }}" target="_blank" class="bold">{{ tracking.number }}</a>
                            </div>
                          </div>
                        }
                      </div>
                      @if (order.fulfillments.length > 1) {
                        <hr />
                      }
                    }
                  </div>
                </div>
              </div>
            </myp-list-item>
          }
        }
        @if (loading) {
          <myp-inline-loader [loading]="true" height="200px" spinnerName="loader"></myp-inline-loader>
        }
      </div>
    }

    @if (displayedSection == "addresses") {
      <div class="container m-b-100">
        <fui-heading [text]="'Address Book'" [level]="5"></fui-heading>
        <br />
        @if (!loading && !addresses?.length) {
          <div class="m-y-20 text-muted">No addresses to display.</div>
        }
        @for (address of addresses; track address) {
          <myp-list-item
            [title]="address.name + ' ' + address.address1 + ' ' + address.formattedArea"
            [metadata]="[
              {
                title: 'Phone',
                value: address.phone,
              },
              {
                title: address.default ? 'Default' : '',
                value: '',
              },
            ]"
            [showImage]="false"
            [includeChevron]="false"
          >
            <div class="button-content">
              <fa-icon icon="pencil" class="action circle-icon-btn" ngbTooltip="Edit Address" tabindex="0" (keyup.enter)="editAddress(address)" (click)="editAddress(address)"></fa-icon>
              <fa-icon icon="times" class="action circle-icon-btn" ngbTooltip="Delete Address" tabindex="0" (keyup.enter)="deleteAddress(address)" (click)="deleteAddress(address)"></fa-icon>
              @if (editingAddresses[address.id]) {
                <fa-icon icon="spinner" animation="spin" class="action circle-icon-btn"></fa-icon>
              }
            </div>
          </myp-list-item>
        }
        <hr class="m-y-50" />
        <a class="btn btn-primary" (click)="addAddress()">Add Address</a>
      </div>
    }

    @if (displayedSection == "gift_cards") {
      <div class="container m-b-100">
        <fui-heading [text]="'Gift Cards'" [level]="5"></fui-heading>
        <br />
        @if (!loading && !giftCards?.length) {
          <div class="m-y-20 text-muted">No gift cards to display.</div>
        }
        @for (card of giftCards; track card) {
          <myp-list-item
            [title]="card.code"
            [metadata]="[
              {
                title: 'Expires',
                value: card.expires,
              },
              {
                title: 'Balance',
                value: card.balance,
              },
            ]"
            [showImage]="true"
            photo="https://cdn.shopify.com/s/files/1/0862/0608/7463/files/GiftCard-FenderOriginal.png?v=1747942094"
            [includeChevron]="false"
            [imageRound]="false"
            [largeImage]="true"
          ></myp-list-item>
        }
        <hr class="m-y-50" />
        <a class="btn btn-primary" (click)="appService.goToFenderShop('products/fender-digital-gift-card', true)">Buy a Gift Card</a>
      </div>
    }
    @if (displayedSection == "recurring") {
      <div class="container">
        <fui-heading [text]="'Recurring Payments'" [level]="5"></fui-heading>
        @if (!recurringPayments?.length) {
          <div class="m-y-20 text-muted">No recurring payments to display.</div>
        }
        @if (!loading && recurringPayments?.length) {
          <myp-user-order-list [orders]="recurringPayments"></myp-user-order-list>
        }
        @if (loading) {
          <myp-inline-loader [loading]="true" height="200px" spinnerName="loader"></myp-inline-loader>
        }
      </div>
    }
  </section>
</div>
